// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"LoadingSpinner_Wrapper__Uqx6I","Spinner":"LoadingSpinner_Spinner__Op8QE","rotate":"LoadingSpinner_rotate__B1Ccw"};